import Vue from 'vue'
import axios from 'axios'


const BASE_API = process.env.VUE_APP_API_URL;



window.PublicAxios = axios.create({
  baseURL: BASE_API,
  timeout: 120000,

  defaults: {
    headers: {
      common: {'X-Requested-With': 'XMLHttpRequest'},
      "Content-type": "application/json",
      "Accept": "application/json",
      "Access-Control-Allow-Credentials": "true",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      "Accept-Encoding": "gzip, deflate"
    },
    withCredentials: true
  }
  // adapter: cache.adapter
});
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate);
import App from './App.vue'

Vue.config.productionTip = false
import "./assets/scss/style.scss";
new Vue({
  render: h => h(App),
}).$mount('#app')
